<template>
	<div class="map">
		<div id="cityMap" style="width:100%;height:100%;"></div>
	</div>
</template>
<script>
	import ahData from "@/common/china";
	export default {
		mounted() {},
		methods: {
			getData(list){
				this.initMapChart(list);
			},
			initMapChart(list) {
				let mapChart = this.$echarts.init(document.getElementById('cityMap'));
				this.$echarts.registerMap("ah", ahData);	
				for(var i in list){
					list[i].name = list[i].city
				}
				const option = {
					// 提示框组件
					tooltip: {
						trigger: 'item', 
						formatter: function (val) {
							return val.data.name + '<br>注册商标: ' + val.data.sb_zhuc + '件' + '<br>有效注册商标: ' + val.data.sb_youx + '件'
						}
					},
					series: [
						{
							type: 'map',
							map: "ah", //上面引入的数据名
							mapType: 'china',
							zoom:1.24,
							label: {
								normal: {
									show: true,
									color: '#fff',
									fontSize:14,
									formatter: function (params) {
										return params.name+"\n"+ '万户：' + params.data.sb_wanh + '件';    //地图上展示文字 + 数值
									},
								},
							},
							itemStyle: {
								normal: {
									borderWidth:1,
									borderColor: "#07E2F4", //地图区域的边框
									areaColor: "#2498CF",
								},
								emphasis: { 
									label: {
										color: "#fff",
										show: true ,
									},
									areaColor: "#4F7FFF",
								}
							},
							data:list,
						}
					],
				};
				mapChart.setOption(option);
				window.addEventListener("resize", function() {
					mapChart.resize();
				});
			},
		},
	};
</script>

<style lang="scss" scoped>
	.map {
		width: 100%;
		height: 100%;
	}
</style>
